/**
 * International phone input for WhatsApp template PHONE_NUMBER buttons.
 *
 * Multi-Chat domain: explicit E.164-style `+[country][national]`.
 * Meta `phone_number` field: alphanumeric, max 20; canonical examples use digits.
 */
/** ITU E.164: up to 15 digits; require at least country + significant national digits. */
const MIN_DIGITS = 8;
const MAX_DIGITS = 15;
/**
 * Parse user-entered international phone for template create/edit.
 * Accepts optional spaces, hyphens, and parentheses after `+`.
 * Does not infer country codes for local numbers.
 */
export function parseWhatsAppTemplatePhoneNumber(raw) {
    const trimmed = raw.trim();
    if (trimmed.length === 0) {
        return { ok: false, reason: "missing" };
    }
    if (!trimmed.startsWith("+")) {
        return { ok: false, reason: "not_international" };
    }
    const rest = trimmed.slice(1);
    if (!/^[\d\s().-]+$/.test(rest)) {
        return { ok: false, reason: "malformed" };
    }
    const digits = rest.replace(/\D/g, "");
    if (digits.length < MIN_DIGITS || digits.length > MAX_DIGITS) {
        return { ok: false, reason: "length" };
    }
    // Country calling codes do not start with 0.
    if (digits.startsWith("0")) {
        return { ok: false, reason: "malformed" };
    }
    return {
        ok: true,
        display: `+${digits}`,
        providerDigits: digits,
    };
}
export function isValidWhatsAppTemplatePhoneNumber(raw) {
    return parseWhatsAppTemplatePhoneNumber(raw).ok;
}
//# sourceMappingURL=whatsapp-template-phone.js.map